import { render } from "./AddContratPage.vue?vue&type=template&id=7c3421e3&ts=true"
import script from "./AddContratPage.vue?vue&type=script&lang=ts"
export * from "./AddContratPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__